<style lang="less">
    .van-icon.van-icon-gift,
    .van-icon.van-icon-aim,
    .van-icon.van-icon-upgrade,
    .van-icon.van-icon-exchange,
    .van-icon.van-icon-home {
        font-family:"dkfont" !important;
        font-style:normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; 
    }
    .van-icon-home::before {
        content: "\e64b";
    }
    .van-tabbar-item--active .van-icon-home::before {
        content: "\e64a";
    }
    .van-icon-exchange::before {
        content: "\e647";
    }
    .van-tabbar-item--active .van-icon-exchange::before {
        content: "\e645";
    }
    .van-icon-upgrade::before {
        content: "\e646";
    }
    .van-tabbar-item--active .van-icon-upgrade::before {
        content: "\e642";
    }
    .van-icon-aim::before {
        content: "\e649";
    }
    .van-tabbar-item--active .van-icon-aim::before {
        content: "\e648";
    }
    .van-icon-gift::before {
        content: "\e644";
    }
    .van-tabbar-item--active .van-icon-gift::before {
        content: "\e643";
    }
</style>

<template>
    <van-tabbar class="k-tabbar" v-model="active" :z-index="9">
        <van-tabbar-item class="r-eid-navHome" icon="home" to="/">首页</van-tabbar-item>
        <van-tabbar-item class="r-eid-navAwards" icon="exchange" to="/match/awards">奖项设置</van-tabbar-item>
        <van-tabbar-item class="r-eid-navPre" icon="upgrade" to="/match/pre">初赛</van-tabbar-item>
        <van-tabbar-item class="r-eid-navFinal" icon="aim" to="/match/final">决赛</van-tabbar-item>
        <van-tabbar-item class="r-eid-navWinners" icon="gift" to="/match/winners">颁奖名单</van-tabbar-item>
    </van-tabbar>
</template>

<script>
    export default {
        name: 'k-tabbar',
        data() {
            return {
                active: 0
            }
        },
        props: ['current'],
        watch: {
            current(index) {
                this.active = index
            }
        },
        created(){
            this.active = this.current
        }
    };
</script>
